import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FullComponent } from './layouts/full/full.component';
import { LoginComponent } from './login/login.component';
import { CustomerListComponent } from './customer/customer-list/customer-list.component';
import { AddCustomerComponent } from './customer/add-customer/add-customer.component';
import { EditCustomerComponent } from './customer/edit-customer/edit-customer.component';
import { CustomerComponent } from './customer/customer.component';
import { UserComponent } from './user/user.component';
import { AddUserComponent } from './user/add-user/add-user.component';
import { EditUserComponent } from './user/edit-user/edit-user.component';
import { UserListComponent } from './user/user-list/user-list.component';
import { ViewUserComponent } from './user/view-user/view-user.component';
import { ActivityComponent } from './activity/activity.component';
import { ShowActivityComponent } from './activity/show-activity/show-activity.component';
import { HighAlertComponent } from './activity/high-alert/high-alert.component';

import { SignupComponent } from './signup/signup.component';
import { SettingComponent } from './setting/setting.component';
import { UserprofileComponent } from './setting/userprofile/userprofile.component';
import { CompanyProfileComponent } from './setting/company-profile/company-profile.component';

import { MobileListComponent } from './mobile/mobile-list/mobile-list.component';
import { AddMobileComponent } from './mobile/add-mobile/add-mobile.component';
import { EditMobileComponent } from './mobile/edit-mobile/edit-mobile.component';
import { MobileComponent } from './mobile/mobile.component';

import { SuperAdminComponent } from './super-admin/super-admin.component';
import { SAddCustomerComponent } from './super-admin/s-add-customer/s-add-customer.component';
import { SEditCustomerComponent } from './super-admin/s-edit-customer/s-edit-customer.component';
import { SCustomerListComponent } from './super-admin/s-customer-list/s-customer-list.component';
import { SUserListComponent } from './super-admin/s-user-list/s-user-list.component';
import { SAddUserComponent } from './super-admin/s-add-user/s-add-user.component';
import { SEditUserComponent } from './super-admin/s-edit-user/s-edit-user.component';
import { ChangePasswordComponent } from './super-admin/change-password/change-password.component';
import { FactoringLanguageComponent } from './super-admin/factoring-language/factoring-language.component';
import { SViewCustomerComponent } from './super-admin/s-view-customer/s-view-customer.component';
import { RedirectComponent } from './redirect/redirect.component'
//import { RoleComponent } from './super-admin/role/role.component';
import { RoleComponent } from './role/role.component';


import { FactoringComponent } from './factoring/factoring.component';
import { FactoringTab1Component } from './factoring/factoring-tab1/factoring-tab1.component';
import { FactoringTab2Component } from './factoring/factoring-tab2/factoring-tab2.component';
import { FactoringTab3Component } from './factoring/factoring-tab3/factoring-tab3.component';

import { FactoringInvoiceComponent } from './mobile/factoring-invoice/factoring-invoice.component';
import { FileMergeComponent } from './mobile/file-merge/file-merge.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

import { ActivateGuard } from './services/activate.guard';
import { UploadsComponent } from './uploads/uploads.component';

import { DownloadComponent } from './download/download.component';
import { DownloadFileComponent } from './download/download-file/download-file.component';

import { CustomerSOAListComponent } from './customer/customer-soa-list/customer-soa-list.component';

import { EmailFilesFactoringComponent } from './mobile/email-files-factoring/email-files-factoring.component';

import { LoadsComponent } from './loads/loads.component';
import { ServicingComponent } from './servicing/servicing.component';
import { CreditRequestComponent } from './credit-request/credit-request.component';

export const Approutes: Routes = [
    {
        path: 'customer',
        component: CustomerComponent,
        canActivate: [ActivateGuard],
        children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' },
            { path: 'customer-list/:status', component: CustomerListComponent },
            { path: 'add-customer', component: AddCustomerComponent },
            { path: 'customerSOA-list', component: CustomerSOAListComponent },
            { path: 'edit-customer/:id', component: EditCustomerComponent },
            
        ]
    },
    {   path: 'user',
        component: UserComponent,
        canActivate: [ActivateGuard],
        children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' },
            { path: 'user-list/:status', component: UserListComponent },
            { path: 'add-user', component: AddUserComponent },
            { path: 'edit-user/:id', component: EditUserComponent,},
            { path: 'view-user/:id', component: ViewUserComponent,},
            { path: 'role', component: RoleComponent,},
            { path: 'upload', component: UploadsComponent,},
        ]
    },      
    {
        path: 'activity',
        component: ActivityComponent,
        canActivate: [ActivateGuard],
        children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' },
            { path: 'show-activity', component: ShowActivityComponent },
            { path: 'high-alert', component: HighAlertComponent },
        ]
    },
    {      
        path: 'mobile',
        component: MobileComponent,
        canActivate: [ActivateGuard],
        children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' },
            { path: 'mobile-list', component: MobileListComponent },
            { path: 'add-mobile/:mode/:id', component: AddMobileComponent },
            { path: 'edit-mobile/:id', component: EditMobileComponent },
            { path: 'factoring-invoice/:id', component: FactoringInvoiceComponent },
            { path: 'file-merge/:id', component: FileMergeComponent }, 
            { path: 'email-files-factoring/:id', component: EmailFilesFactoringComponent}
        ]
    },
    {
        path: 'factoring',
        component: FactoringComponent,
        canActivate: [ActivateGuard],
        children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' },
            { path: 'factoring-tab1', component: FactoringTab2Component },
            { path: 'factoring-tab2', component: FactoringTab3Component },
            { path: 'factoring-tab3', component: FactoringTab1Component },
        ]
    },
    {
        path: 'credit-request',
        component: CreditRequestComponent,
        canActivate: [ActivateGuard],
        data: {
            title: 'Credit Request',
        }
    },
    {
        path: 'loads',
        component: LoadsComponent,
        canActivate: [ActivateGuard],
        data: {
            title: 'Loads',
        }
    },
    {
        path: 'servicing',
        component: ServicingComponent,
        canActivate: [ActivateGuard],
        data: {
            title: 'CCC Servicing',
        }
    },
    {
        path: 'super-admin',
        component: SuperAdminComponent,
        canActivate: [ActivateGuard],
        children: [
            { path: '', redirectTo: '/super-admin/customer-list/:status', pathMatch: 'full' },
            { path: 'customer-list/:status', component: SCustomerListComponent },
            { path: 'add-customer', component: SAddCustomerComponent },
            { path: 'edit-customer/:id', component: SEditCustomerComponent },
            { path: 'view-customer/:id', component: SViewCustomerComponent },
            { path: 'user-list', component: SUserListComponent },
            { path: 'add-user', component: SAddUserComponent },
            { path: 'edit-user/:id', component: SEditUserComponent },
            { path: 'edit-profile', component: ChangePasswordComponent },
            { path: 'factoring-language', component: FactoringLanguageComponent },       
        ]
    },

    {
        path: 'login',
        component: LoginComponent,
        data: {
            title: 'Login',
        }
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        data: {
            title: 'forgot-password',
        }
    },
  
   
    {
        path: 'setting',   
        component: SettingComponent,
        canActivate: [ActivateGuard],
        children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' },
            { path: 'user-profile', component: UserprofileComponent },
            { path: 'company-profile', component: CompanyProfileComponent },
        ]
    },

    {
        path: 'download',   
        component: DownloadComponent,
        children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' },
            { path: 'download-file/:id', component: DownloadFileComponent },
        ]
    },
    
    {
        path: 'signup',
        component: SignupComponent,
        data: {
            title: 'signup',
        }
    },
    {
        path: 'redirect',
        component: RedirectComponent,
        data: {
            title: 'Redirect',
        }
    },
    {
        path: '**',
        component: LoginComponent,
        data: {
            title: 'Login',
        }
    },

];